import { graphql } from 'gatsby';

import * as styles from './Video.module.css';

type Props = {
  className?: string;
  content: Omit<ContentfulComponentSharedVideo, '__typename' | 'contentful_id'>;
};

const Video = ({ content, className = '' }: Props): JSX.Element => {
  const { videoTitle, url } = content;
  const embedUrl = url.replace('watch?v=', 'embed/');
  const hideMoreVids = 'rel=0';
  const hideYTlogo = 'modestbranding=1';
  const videoUrl = `${embedUrl}?${hideMoreVids}&${hideYTlogo}`;

  return (
    <div className={`${styles.wrapper} ${className}`}>
      {videoTitle && <h2 className={styles.title}>{videoTitle}</h2>}
      <div className={styles.videoContainer}>
        <iframe
          className={styles.video}
          src={videoUrl}
          title={videoTitle}
          frameBorder='0'
          allow='accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture'
          allowFullScreen
        ></iframe>
      </div>
    </div>
  );
};

export default Video;

export type ContentfulComponentSharedVideo = {
  __typename: 'ContentfulComponentSharedVideo';
  videoTitle?: string;
  url: string;
};

export const query = graphql`
  fragment Video on ContentfulComponentSharedVideo {
    videoTitle: title
    url
  }
`;
